import React, { useEffect, useState } from "react";

import CheckboxPicklistDisplay from "./read-only";
import Modal from "../../modal";

import { Checkbox } from "../inputs";
import { getProvider } from "../shared/data";
import { checkMultiMatch } from "../typeahead/lib/check-match";

import "./checkbox-picklist.scss";
import { attributeUUID } from "../../../shared/attribute-uuid";

const picklistHeaderWhitelist = [attributeUUID.healthBeautyClaims, attributeUUID.healthIngredientClaims];

const CheckboxPicklist = (props) => {
    const [options, setOptions] = useState([]);
    const [selections, setSelections] = useState(props.defaultValue || []);
    const [showModal, setShowModal] = useState(false);
    const showAttributeName = picklistHeaderWhitelist.some((uuid) => uuid === props.attribute.uuid);

    useEffect(() => {
        async function fetchData() {
            const data = await getProvider(props.provider);

            if (!data) {
                return;
            }

            setOptions(data);
        }

        fetchData();
    }, []);

    useEffect(() => {
        if (!checkMultiMatch(props.defaultValue || [], selections)) {
            setSelections(props.defaultValue || []);
        }
    }, [props.defaultValue]);

    const closeModal = () => {
        setShowModal(false);
    };

    const handleSelection = (sel, value) => {
        // SAVE full selections
        if (value) {
            setSelections([...selections, sel]);
        } else {
            setSelections(selections.filter((s) => s.value !== sel.value));
        }
    };

    const onCancel = () => {
        setSelections(props.defaultValue || []);
        closeModal();
    };

    const onSave = () => {
        props.updateOnChange(props.name, selections);
        closeModal();
    };

    const selectionValues = selections.map((s) => s.value);
    const displayOptions = options.map((opt) => {
        return (
            <li key={`checkbox_${opt.value}`}>
                <Checkbox
                    label={opt.text}
                    name={opt.value}
                    value={selectionValues.includes(opt.value)}
                    updateOnChange={(id, value) => {
                        handleSelection(opt, value);
                    }}
                />
            </li>
        );
    });

    return (
        <div className="checkbox-picklist">
            <Modal
                show={showModal}
                onClose={closeModal}
            >
                <div className="button-group ">
                    <button
                        className="button"
                        onClick={onCancel}
                    >
                        Cancel
                    </button>
                    {showAttributeName && <h1 className="txt-center">{props.attribute.name}</h1>}
                    <button
                        className="button -primary -right"
                        onClick={onSave}
                    >
                        Save
                    </button>
                </div>
                <h4 className="txt-center">Select all that apply</h4>
                <ul className="checkbox-picklist-options">{displayOptions}</ul>
            </Modal>
            <button
                className="button"
                disabled={props.disabled}
                onClick={() => {
                    setShowModal(true);
                }}
            >
                Checkbox Picklist
            </button>
            {props.defaultValue && <CheckboxPicklistDisplay selections={props.defaultValue} />}
        </div>
    );
};

export default CheckboxPicklist;
